<template>
  <div class="flex-body" v-show="!$route.query.token">
    <div class="login-header">
      <div class="h-title">
        <span class="span-style"> 习训云 - 实验实训管理平台</span>
        <span class="href-style" :style="{ position: 'absolute', right: '6%' }">
          <el-link href="https://www.xixunyun.com/login.html" target="_blank">实习平台</el-link>
          <el-link href="https://www.xixunyun.com/Application.html" target="_blank">学校试用申请</el-link>
          <el-link href="http://www.vanber.cn" target="_blank">关于我们</el-link>
        </span>

      </div>
    </div>
    <div class="login-content">
      <div class="inline-div">
        <div class="login-text">

          <img src="@/assets/image/bac-img.png" />
        </div>
        <div class="login-win">
          <p style="font-family: 黑体;font-weight: 500;">欢迎登录<span>实训实验管理平台</span></p>
          <!-- <i class="el-icon-info" style=""></i> -->
          <div class="school input">
            <p><i class="el-icon-location"></i>请选择学校</p>
            <!-- <el-autocomplete class="school input" v-model="loginForm.school" focus :fetch-suggestions="querySearch" placeholder="请选择学校" @select="handleSelect"></el-autocomplete> -->
            <!-- <el-input placeholder="请选择学校" focus v-model="loginForm.school"> -->
            <!-- </el-input> -->
            <el-select v-model="loginForm.schoolname" placeholder="请选择学校" filterable @change="handleSelect"
              @focus="handleFocus">
              <el-option v-for="item in restaurants" :key="item.id" :label="item.fdName" :value="item.fdName"
                :disabled="item.disabled == 1">
              </el-option>
            </el-select>
          </div>
          <div class="user input">
            <p><i class="el-icon-user-solid"></i>请输入账号</p>
            <el-input placeholder="请输入账号" v-model="loginForm.username">
            </el-input>
          </div>
          <div class="password input">
            <p><i class="el-icon-lock"></i>请输入密码</p>
            <el-input type="password" @keyup.enter.native="login" placeholder="请输入密码" show-password
              v-model="loginForm.password">
            </el-input>
          </div>
          <!-- <div class="mistake-info" v-if="message">{{ message }}</div> -->
          <div class="login_btn">
            <div class="secret">
              <el-checkbox v-model="checked">请您阅读并同意<el-link type="primary"
                  @click.stop="dialogVisible = true">《隐私协议》</el-link></el-checkbox>
            </div>
            <el-button type="primary" @click="login">登&nbsp;&nbsp;&nbsp;&nbsp;录</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="login-footer">
      <p>万博云信（北京）教育科技有限公司</p>
      <p>
        Copyright © 2015-2016 Vanber. All Rights Reserved. 京ICP备15033449号-2
      </p>
      <p>院校咨询：189 1165 6408 渠道合作：135 2057 3697</p>
      <p>邮箱：xixun@vanber.cn</p>
      <p><img src="@/assets/image/ga.png" />京公网安备11010802031338号</p>
    </div>
    <el-dialog title="" :visible.sync="dialogVisible" width="720px">
      <div style="padding: 12px;">
        <About />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Cookies from 'js-cookie';
import About from './About.vue'

export default {
  name: 'Login',
  components: {
    About
  },
  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        schoolname: '',
      },
      dialogVisible: false,
      message: '',
      system: '',
      restaurants: [],
      offsetLeft: 0,
      screenWidth: window.innerWidth,
      checked: false,
    };
  },
  created() {
    console.log(this.$route)
    if (this.$route.query && this.$route.query.token) {
      this.tokenLogin(this.$route.query.token);
      localStorage.setItem('token', this.$route.query.token)
    } else {
      localStorage.setItem('token', '')
    }
    if (this.$route.query.system) {
      localStorage.setItem('system', this.$route.query.system)
      this.system = this.$route.query.system
    } else {
      localStorage.setItem('system', '')
    }

    this.checked = localStorage.getItem('isAgree') == 1 ? true : false

    this.$store.commit('setCurrentModule', 'jbxxgl');
    Cookies.remove('userToken')

    // console.log(this.$route)
  },
  mounted() {
    // window.addEventListener('beforeunload', (e) => {
    //   // 执行保存操作（注意：只能同步操作）
    //   localStorage.removeItem("schools")
    // });
    if (!localStorage.getItem('schools')) {
      this.loadAll();
    } else {
      this.restaurants = JSON.parse(localStorage.getItem('schools'))
      this.setSchool()
    }
    this.offsetLeft = document.getElementsByClassName('login-win')[0].offsetLeft + 60;
  },
  methods: {
    handleSelect(item) {
      console.log(item);
      // window.localStorage.setItem('schoolid', item);
      window.localStorage.setItem('schoolname', item);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleFocus() {
      // this.loginForm.schoolname = '';
    },
    async loadAll() {
      // let res = await this.$api.instance.getTrainSchools(),
      let res = await this.$api.instance.getXixunSchools(),
        data = [];
      if (res.code == 0 && res.data) {
        const filerSchool = [2287]
        // this.$store.commit('setOrgans', JSON.stringify(res.data));
        data = res.data.filter(item => {
          return filerSchool.indexOf(item.id) == -1;
        });

        // this.loginForm.schoolid = 1
      }
      // else {
      //   return [{ value: '万博云信学院', id: '46' }];
      // }
      // console.log(data)
      this.restaurants = data;
      localStorage.setItem('schools', JSON.stringify(data));
      this.setSchool()
    },
    // loopArr(arr){
    //   arr.map(item=>{
    //     if(item.school_id){
    //       this.restaurants.push({id:item.school_id,name:item.school_name})
    //     }
    //     if(item.list&&item.list.length){
    //       this.loopArr(item.list)
    //     }
    //   })
    // },
    setSchool() {
      let storage = window.localStorage;
      if (storage.getItem('schoolname')) {
        this.loginForm.schoolname = storage.getItem('schoolname');
      }
    },
    //获取组织结构
    async getOrgans() {
      let res = await this.$api.instance.getOrgansMy();
      if (res.code == 0) {
        this.$store.commit('setOrgans', JSON.stringify(res.data));
      }
    },
    async tokenLogin(token) {
      let res = await this.$api.login.tokenLogin({ token });
      if (res.code == 0) {
        this.$message({
          message: '登录成功！',
          type: 'success',
          center: true,
          showClose: true,
          duration: 2000,
        });
        if (res.data) {
          this.$store.commit('setUserInfo', JSON.stringify(this.$until.deleteNullPrototype(res.data)));
          // Cookies.set('userToken', `userToken:${res.data.userToken}`);
          Cookies.set('userToken', `${res.data.userToken}`);

          this.$store.commit('setToken', res.data.userToken);
          // if (res.data.schoolid) {
          // this.getOrgans(res.data.schoolid);
          this.getOrgans();
          // }
          this.$store.commit('setMenuItems', []);
          this.getMenus();
          // 公共菜单（menuItems）数据源：接口 api/menu/setting/list
          this.$store.dispatch('getMenuItems');
          // this.$router.push('/');
        }
      } else {
        // this.$message({
        //   message: res.msg,
        //   center: true,
        // });
      }
    },
    async login() {
      if (!this.loginForm.schoolname) {
        this.message = '学校未选择！';

      } else if (!this.loginForm.username) {
        this.message = '账号不能为空！';
      } else if (!this.loginForm.password) {
        this.message = '密码不能为空！';
      } else if (!this.checked) {
        this.message = '请阅读并同意隐私协议！';
      } else {
        localStorage.setItem("isAgree", 1)
        this.message = '';
      }
      if (this.message) {
        this.$message({
          message: this.message,
          type: 'error',
          center: true,
          showClose: true,
          duration: 2000,
        });
        return
      }
      let res = await this.$api.login.loginIn(this.loginForm);
      if (res.code == 0) {
        this.$message({
          message: '登录成功！',
          type: 'success',
          center: true,
          showClose: true,
          duration: 2000,
        });
        if (res.data) {
          this.$store.commit('setUserInfo', JSON.stringify(this.$until.deleteNullPrototype(res.data)));
          Cookies.set('userToken', `${res.data.userToken}`);
          this.$store.commit('setToken', res.data.userToken);
          this.getOrgans();
          this.getMenus();
          // 公共菜单（menuItems）数据源：接口 api/menu/setting/list
          this.$store.dispatch('getMenuItems');
          // this.$router.push('/');
        }
      } else {
        // this.$message({
        //   message: res.msg,
        //   center: true,
        // });
      }
    },
    async getMenus() {
      let res = await this.$api.instance.getMenuItems({});
      if (res.code == 0 && res.data && res.data.menu) {
        // this.menuItems = res.data.menu;
        this.$store.commit('setMenu', res.data.menu);
        if (this.screenWidth < 1000) {
          this.$router.push({
            path: `/h5HomePage`,
          });
          return
        }
        if (this.$route.params && this.$route.params.key) {
          this.$router.push({
            path: `/${this.$route.params.key}`,
          });
          return
        }
        let parseMenu = JSON.parse(res.data.menu);
        if (parseMenu.length) {
          if (parseMenu[0]) {
            this.$router.push({
              path: parseMenu[0].path || parseMenu[0].childs[0].path,
            });
          }
        } else {
          this.$message({
            type: 'error',
            message: '未分配菜单',
          });
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.secret {
  padding: 8px 0px 16px 44px;
  text-align: left;

  /deep/.el-link--inner {
    font-size: 14px;
    margin-left: 0;
    line-height: 20px;
  }
}

.flex-body {
  display: flex;
  flex-direction: column;
  height: 100%;

  .login-header {
    height: 72px;
    width: 100%;
    border-top: 2px solid #4578ed;
    box-sizing: border-box;
    background: #fff;

    .h-title {
      height: 100%;
      margin: 0 auto;
      width: 100%;
      text-align: left;
      line-height: 72px;
      padding-left: 72px;
      box-sizing: border-box;
      position: relative;

      .span-style {
        font-weight: bold;
        color: #272b34;
        font-size: 28px;
        font-family: Alimama ShuHeiTi, Alimama ShuHeiTi;
      }
    }
  }

  .login-content {
    //background: #4379ed;
    // background-image: url('../assets/image/bac.jpg');
    //background-position: center center;
    width: 100%;
    flex: 1;
    background-size: auto 100%;

    .inline-div {
      // width: 1280px;
      width: 100%;
      height: 100%;
      margin: 0 auto;
      // background: url('../assets/image/bac.png');
      background-size: 100% 100%;
      position: relative;
    }
  }

  .login-footer {
    width: 100%;
    height: 120px;
    background: #fff;
    padding-top: 16px;
    font-size: 13px;
    border-bottom: 2px solid #4578ed;
    box-sizing: border-box;

    p {
      letter-spacing: 1px;
      margin-bottom: 1px;
      color: #111;
    }
  }
}



.login-win {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  // height: 500px;
  width: 404px;
  background: #fefefe;
  margin-right: 0px;
  padding: 24px 0 64px;
  text-align: center;
  border-radius: 12px;
  float: right;

  p {
    margin: 32px 0 24px;
    letter-spacing: 1.5px;
    font-size: 22px;
    color: #3D3D3D;

    span {
      color: #507AFC;
      letter-spacing: 1.1px;
    }

    i {
      font-size: 16px;
      margin-right: 2px;
    }
  }

  i {
    font-size: 32px;
    color: #616f67;
    // margin-bottom: 16px;
  }

  .input {
    width: 80%;
    margin: 0 auto;
    text-align: center;
    padding-top: 16px;

    p {
      text-align: left;
      font-size: 14px;
      margin: 0 0 8px;
      letter-spacing: 1px;
    }
  }

  .mistake-info {
    color: #de5050;
    text-align: left;
    font-size: 14px;
    width: 244px;
    margin: 8px auto;
    height: 25px;
  }
}

.login_btn {
  margin-top: 8px;
}

@media screen and (min-width: 1000px) {
  .span-style {
    font-size: 32px;
  }

  .login-header {
    min-width: 1280px;
  }

  .login-content {
    min-width: 1280px;
    background: linear-gradient(-311deg, #A3CDF0 0%, #2074F1 100%);
  }

  .login-footer {
    min-width: 1280px;
  }

  .login-win {
    margin-right: 8%;
  }

  .login-text {
    position: absolute;
    // top: 50%;
    // transform: translateY(-40%);
    left: 4%;
    height: 100%;
    top: 10%;

    // background-image: url('../assets/image/bac-img.png');
    // background-position: center center;
    img {
      height: 95%;
      // width: 90%;
    }
  }
}

/* 针对手机的样式 */
@media screen and (max-width: 1000px) {
  .span-style {
    font-size: 20px;
  }

  .href-style {
    display: none;
  }

  .login-text {
    display: none;
  }

  .login-content {
    background-image: none !important;
    background: #4379ed;
  }

  .login-win {
    float: none;
    margin: 0 auto;
    width: 90%;
    ;
  }

  .login-footer {
    display: none;

  }

  .h-title {
    padding: 0 !important;
    text-align: center !important;
  }


}

// /deep/.el-select .el-input__inner {
//   background: #4578ed;
//   color: #f5f5f5;
// }

/deep/.el-input__inner {
  box-shadow: none;
  height: 48px;
  line-height: 48px;
  border-radius: 5px;
  // background: #e8f0fe;
  // color: #272b34;
  // font-weight: bold;
  // text-align: center;
  font-size: 16px;
  // -webkit-box-shadow: 0 0 0px 1000px #d0e7ef5c inset;
  // -webkit-text-fill-color: #4578ed;
  border: 1px #616f6733 solid;
}

/deep/.el-button--primary {
  // background-color: #272b34;
  border: 0;
  border-radius: 5px;
  color: #fff;
  // font-weight: bold;
  // letter-spacing: 20px;
  font-size: 16px;
  width: 164px;
}

/deep/ input::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #b9bdd0;
}

/deep/ input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #b9bdd0;
}

/deep/ input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #b9bdd0;
}

/deep/ input:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #b9bdd0;
}

/deep/ .el-select {
  width: 100%;
}

/deep/.el-link--inner {
  font-size: 18px;
  margin-left: 16px;
}
</style>